import {
  AfterViewInit,
  Component,
  EventEmitter,
  Input,
  OnChanges,
  Output,
  SimpleChanges,
} from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { fromEvent } from 'rxjs';
import { map } from 'rxjs/operators';

@Component({
  selector: 'app-upload-file',
  templateUrl: './upload-file.component.html',
  styleUrls: ['./upload-file.component.scss'],
})
export class UploadFileComponent implements AfterViewInit, OnChanges {
  @Input() fileTypes: string;
  @Input() uploadText: string;
  @Input() uploadedText: string;
  @Input() isUploaded: boolean;
  @Output() uploadEvent: EventEmitter<File> = new EventEmitter<File>();
  iconUpload = 'attach_file';

  constructor(private snackBarService: MatSnackBar) {}

  ngOnChanges(changes: SimpleChanges) {
    if (changes?.isUploaded?.currentValue) {
      this.iconUpload = 'done';
      this.uploadText = this.uploadedText;
    }
  }

  /**
   * Pending event to the input file
   */
  ngAfterViewInit(): void {
    const element = document.getElementById('attachFileInput');
    const change = fromEvent(element, 'change');
    const result = change.pipe(map((i: any) => i.currentTarget.files));
    result.subscribe((files) => this.uploadAttachFile(files));
  }

  /**
   * Sets the file to the form and validates the file type
   * @param files file list
   * @returns an snack bar when the file type is incorrect
   */
  uploadAttachFile(files) {
    const file = files[0];
    const format = `.${file.name.split('.').pop()}`;
    const isvalid = this.fileTypes.includes(format.toLowerCase());
    if (isvalid === false) {
      return this.snackBarService.open('Document type is not valid', null, {
        duration: 3000,
      });
    }
    this.uploadText = this.uploadedText;
    this.iconUpload = 'done';
    this.uploadEvent.emit(file);
  }
}
